import { render, staticRenderFns } from "./Players.vue?vue&type=template&id=4d3095b4&scoped=true&"
import script from "./Players.vue?vue&type=script&lang=js&"
export * from "./Players.vue?vue&type=script&lang=js&"
import style0 from "./Players.vue?vue&type=style&index=0&id=4d3095b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3095b4",
  null
  
)

export default component.exports